module.exports = flarum.extensions['fof-seo'];